import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// @ts-ignore
import { FeatureTypes, ProductType } from '../billing-types';
import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingSectionHeader from '@/components/Billing/BillingSectionHeader.vue';
import {
	LEARN_MORE_BASE_LINK,
	MEMBER_MANAGEMENT_LINK,
	HOW_IT_WORKS_EXPLANATIONS,
	SECTION_DESCRIPTION,
	LEARN_MORE_LINK,
} from '@/components/Billing/billing-service.const';
import { addBigNumberSuffix } from '@/utils/helpers';
import { pluralize } from '@/utils/language-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamFeaturesSectionHeader',
  setup(__props) {

const { useEntitlementById, customerData } = useBilling();
const useEntitlement = useEntitlementById();
const productType = ProductType.TeamFeatures;
const learnMoreBaseLink = LEARN_MORE_BASE_LINK;
const memberManagementLink = MEMBER_MANAGEMENT_LINK;
const subTitle = computed(() => SECTION_DESCRIPTION[productType]);
const learnMoreLink = computed(() => LEARN_MORE_LINK[productType]);

const amountOfStandardMembers = computed(() => customerData.value.standard_users_count);
const amountOfPremiumMembers = computed(() => customerData.value.premium_users_count);
const totalAmountOfTasks = computed(() => useEntitlement.value(FeatureTypes.TeamTasks)?.entitlement?.usage_limit || 'unlimited');
const standardMembersSentence = computed(() => pluralize('standard member', amountOfStandardMembers.value, true));
const premiumMembersSentence = computed(() => pluralize('premium member', amountOfPremiumMembers.value, true));
const amountOfTasksSentence = computed(() =>
	typeof totalAmountOfTasks.value === 'string' ? 'unlimited tasks' : addBigNumberSuffix(totalAmountOfTasks.value) + ' tasks'
);
const currentBillingCycle = computed(
	() => `${standardMembersSentence.value}, ${premiumMembersSentence.value} and ${amountOfTasksSentence.value}`
);

const howItWorksExplanations = computed(() => HOW_IT_WORKS_EXPLANATIONS[productType]);

return { __sfc: true,useEntitlementById, customerData, useEntitlement, productType, learnMoreBaseLink, memberManagementLink, subTitle, learnMoreLink, amountOfStandardMembers, amountOfPremiumMembers, totalAmountOfTasks, standardMembersSentence, premiumMembersSentence, amountOfTasksSentence, currentBillingCycle, howItWorksExplanations, BillingSectionHeader }
}

})